export const env = {
    BASE_API_URL: 'https://charmy-api-3.cupist.de',
    BASE_STORAGE_URL: 'https://s3.ap-northeast-2.amazonaws.com/charmy-test/',
    ENV_NAME: 'dev'
}